import './InvitesDialogSectionToggle.scss';

import * as React from 'react';

import { translate } from '~l10n/client';

import ToggleSwitch from '~shared/components/ToggleSwitch/ToggleSwitch';

interface InvitesDialogSectionToggleProps {
  label: string;
  description: string;
  on: boolean;
  isDisabled: boolean;
  onEnabledChange: (enabled: boolean) => void;
}

export function InvitesDialogSectionToggle({
  label,
  description,
  on,
  isDisabled,
  onEnabledChange,
}: InvitesDialogSectionToggleProps) {
  return (
    <div className="invites-dialog-section-toggle">
      <div className="label text-base font-700 text-display leading-8">
        {label}
      </div>
      <div className="description text-base font-400 text-body leading-8">
        {description}
      </div>
      <div className="toggle">
        <ToggleSwitch
          label={translate('Enable')}
          on={on}
          disabled={isDisabled}
          onChange={onEnabledChange}
        />
      </div>
    </div>
  );
}
